/* Prime Phones — Notify me (30 Sept 2026).
   - The sheet (snippets/pp-notify-sheet.liquid): opened from a sold phone's
     "Notify me" on a product card, filled with that phone.
   - The product page card (snippets/pp-restock.liquid).
   Both send the store's contact form without leaving the page. Shopify
   answers a contact form with a redirect to return_to; we point it at the
   tiny /cart.js so nothing heavy downloads. If Shopify wants its spam check
   (a redirect to /challenge), the form is sent the normal way instead, so
   the customer can complete it. */
(function () {
  if (window.PPNotify) return;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var sheet = document.querySelector('[data-ppnt-sheet]');
  var panel = sheet && sheet.querySelector('.ppnt-sheet__panel');
  var lastTrigger = null;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfgEl = document.getElementById('ppnt-words');
  var words = {};
  try { words = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { words = {}; }

  function tpl(el, series) {
    var t = el.getAttribute('data-ppnt-tpl');
    if (t != null) el.textContent = t.split('[series]').join(series);
  }

  function field(form, key) {
    return form.querySelector('[data-ppnt-f="' + key + '"]');
  }

  function reset(root) {
    var form = root.querySelector('.ppnt__form');
    var done = root.querySelector('.ppnt__done');
    root.classList.remove('is-done', 'is-busy');
    if (form) {
      form.hidden = false;
      var msg = form.querySelector('.ppnt__msg');
      if (msg) { msg.hidden = true; msg.textContent = ''; }
      form.querySelectorAll('.ppnt__input').forEach(function (i) { i.removeAttribute('aria-invalid'); });
    }
    if (done) done.hidden = true;
  }

  /* ---------- the sheet ---------- */
  function fill(d) {
    var series = d.s || d.n || '';
    var img = sheet.querySelector('[data-ppnt-img]');
    if (d.img) { img.src = d.img; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; }
    sheet.querySelector('[data-ppnt-name]').textContent = d.n || d.t || '';
    sheet.querySelector('[data-ppnt-sub]').textContent = d.sub || '';
    sheet.querySelectorAll('[data-ppnt-tpl]').forEach(function (el) { tpl(el, series); });
    var link = sheet.querySelector('[data-ppnt-series-link]');
    if (link) {
      if (d.su && d.sn > 0) { link.href = d.su; link.hidden = false; } else { link.hidden = true; }
    }
    var form = sheet.querySelector('.ppnt__form');
    field(form, 't').value = d.t || '';
    field(form, 'link').value = d.url ? window.location.origin + d.url : '';
    field(form, 's').value = series;
    field(form, 'pid').value = d.pid || '';
    field(form, 'back').value = window.location.pathname;
    panel.setAttribute('data-series', series);
  }

  function open(trigger) {
    if (!sheet) { window.location.href = trigger.href; return; }
    var d = {};
    try { d = JSON.parse(trigger.getAttribute('data-pp-notify')); } catch (e) { window.location.href = trigger.href; return; }
    lastTrigger = trigger;
    reset(panel);
    fill(d);
    sheet.hidden = false;
    document.documentElement.classList.add('ppnt-open');
    void panel.offsetWidth;
    sheet.classList.add('is-open');
    var email = panel.querySelector('input[type="email"]');
    setTimeout(function () {
      if (window.matchMedia('(pointer: fine)').matches && email) email.focus({ preventScroll: true });
      else panel.focus({ preventScroll: true });
    }, reduced ? 0 : 120);
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('ppnt-open');
    sheet.dispatchEvent(new Event('ppnt:closed'));
    var done = function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; };
    if (reduced) done(); else setTimeout(done, 460);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
  }

  if (sheet) {
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ppnt-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) close();
      /* Keep the keyboard inside while it's open. */
      if (e.key === 'Tab' && sheet.classList.contains('is-open')) {
        var f = [].slice.call(panel.querySelectorAll('a[href]:not([hidden]), button:not([disabled]), input:not([type="hidden"])')).filter(function (el) { return el.offsetParent; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    /* Phones: swipe the sheet down to close. */
    var y0 = null, dy = 0;
    panel.addEventListener('touchstart', function (e) {
      if (panel.scrollTop > 0 || e.target.closest('input, label, button, a')) return;
      y0 = e.touches[0].clientY; dy = 0; sheet.classList.add('is-dragging');
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    var end = function () {
      if (y0 === null) return;
      sheet.classList.remove('is-dragging');
      panel.style.transform = '';
      if (dy > 90) close();
      y0 = null;
    };
    panel.addEventListener('touchend', end);
    panel.addEventListener('touchcancel', end);
    window.addEventListener('pageshow', function (e) { if (e.persisted) close(); });

    /* Phones: while typing, the sheet sits on top of the keyboard (the
       email box and the button stay in sight), and it goes back down with
       the keyboard — also when the keyboard is hidden without leaving the
       box (Android's back button / swipe-down), when the box lets go of the
       cursor, as iPhone's Done does (1 Oct 2026). */
    var vv = window.visualViewport;
    var kbUp = false;
    var typing = function () {
      var a = document.activeElement;
      return a && panel.contains(a) && a.matches('input[type="email"], input[type="tel"], input[type="text"]') ? a : null;
    };
    var fitSheet = function () {
      if (!vv || sheet.hidden || !sheet.classList.contains('is-open')) return;
      var a = typing();
      var squeezed = a && (vv.scale || 1) < 1.05 && vv.height < window.innerHeight - 60;
      if (squeezed) {
        kbUp = true;
        panel.style.bottom = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)) + 'px';
        panel.style.maxHeight = Math.round(vv.height - 8) + 'px';
        /* The button into view too when both fit, the box always. */
        var go = panel.querySelector('button[type="submit"]');
        if (go) go.scrollIntoView({ block: 'nearest' });
        a.scrollIntoView({ block: 'nearest' });
        return;
      }
      if (kbUp && a) a.blur();
      kbUp = false;
      panel.style.bottom = '';
      panel.style.maxHeight = '';
    };
    if (vv) {
      vv.addEventListener('resize', fitSheet);
      vv.addEventListener('scroll', fitSheet);
    }
    /* A tap on the button (or a link) while typing keeps the cursor until
       the tap has done its job, so the sheet doesn't drop away under the
       finger as the keyboard starts to close. */
    panel.addEventListener('mousedown', function (e) {
      if (typing() && e.target !== document.activeElement && e.target.closest('button, a, input[type="checkbox"]')) e.preventDefault();
    });
    sheet.addEventListener('ppnt:closed', function () {
      kbUp = false;
      panel.style.bottom = '';
      panel.style.maxHeight = '';
    });
  }

  /* ---------- sending (sheet and product page) ---------- */
  function say(form, text) {
    var msg = form.querySelector('.ppnt__msg');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = !text;
  }

  function finish(root, form) {
    root.classList.remove('is-busy');
    root.classList.add('is-done');
    form.hidden = true;
    var done = root.querySelector('.ppnt__done');
    if (done) {
      done.hidden = false;
      var title = done.querySelector('.ppnt__done-title');
      if (title) title.focus({ preventScroll: true });
    }
  }

  function send(form, e) {
    var root = form.closest('[data-ppnt]') || form.parentElement;
    var email = form.querySelector('input[type="email"]');
    if (!email || !EMAIL.test(email.value.trim())) {
      e.preventDefault();
      if (email) { email.setAttribute('aria-invalid', 'true'); email.focus(); }
      say(form, words.invalid || 'Please enter a valid email address.');
      return;
    }
    if (form.dataset.native === '1') return; /* the normal way (spam check) */
    e.preventDefault();
    if (root.classList.contains('is-busy')) return;
    email.removeAttribute('aria-invalid');
    say(form, '');
    root.classList.add('is-busy');
    var data = new FormData(form);
    var back = data.get('return_to');
    data.set('return_to', '/cart.js');
    fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new URLSearchParams(data), credentials: 'same-origin', headers: { Accept: 'application/json, text/html' } })
      .then(function (res) {
        if (/\/challenge/.test(res.url)) {
          /* Shopify wants its spam check: send it the normal way. */
          form.dataset.native = '1';
          var r = form.querySelector('input[name="return_to"]');
          if (r) r.value = back || window.location.pathname;
          root.classList.remove('is-busy');
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
          return;
        }
        if (!res.ok) throw new Error('status ' + res.status);
        finish(root, form);
      })
      .catch(function () {
        root.classList.remove('is-busy');
        say(form, words.error || 'That didn’t go through. Please try again, or message us on WhatsApp.');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.ppnt__form');
    if (form) send(form, e);
  }, true);

  /* Product page, sent the normal way (no script / spam check): show done. */
  document.querySelectorAll('.ppnt--inline .ppnt__posted').forEach(function (p) {
    var form = p.closest('.ppnt__form');
    var root = form && form.closest('[data-ppnt]');
    if (root) finish(root, form);
  });

  window.PPNotify = { open: open, close: close };
})();
